import { createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "w-lg-500px bg-white rounded shadow-sm p-10 p-lg-15 mx-auto" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "text-center mb-10" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "text-gray-400 fw-bold fs-4" }, "Yeni Entegrasyon Ekle")
], -1)
const _hoisted_3 = { class: "fv-row mb-10" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder text-gray-900 fs-6" }, "Platform", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("option", { value: "Yemeksepeti" }, "Yemeksepeti", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("option", { value: "Getir" }, "Getir", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("option", { value: "Trendyol" }, "Trendyol", -1)
const _hoisted_8 = [
  _hoisted_5,
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = { key: 0 }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder text-gray-900 fs-6" }, "Satıcı Id", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = {
  key: 1,
  class: "form-label fw-bolder text-gray-900 fs-6"
}
const _hoisted_15 = {
  key: 2,
  class: "form-label fw-bolder text-gray-900 fs-6"
}
const _hoisted_16 = {
  key: 0,
  class: "form-label fw-bolder text-gray-900 fs-6"
}
const _hoisted_17 = {
  key: 1,
  class: "form-label fw-bolder text-gray-900 fs-6"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_19 = { class: "d-flex flex-wrap justify-content-center pb-lg-0" }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-5 fw-bold mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Şube Seçiniz")
], -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_23 = ["onClick"]
const _hoisted_24 = ["onClick"]
const _hoisted_25 = {
  key: 1,
  class: "w-100"
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-5 fw-bold mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Doğrulama Kodu")
], -1)
const _hoisted_27 = { class: "text-gray-500 fs-7 mb-3" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_29 = { key: 2 }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-5 fw-bold mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Şube Seçiniz")
], -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_32 = ["onClick"]
const _hoisted_33 = { key: 3 }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-5 fw-bold mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Menü Seçiniz")
], -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_36 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _withDirectives(_createElementVNode("select", {
        class: "form-select form-select-solid",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.Platform) = $event))
      }, _hoisted_8, 512), [
        [_vModelSelect, _ctx.Platform]
      ]),
      _hoisted_9,
      (_ctx.Platform == 'Trendyol')
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _hoisted_11,
            _hoisted_12,
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.supplierId) = $event)),
              class: "form-control form-control-solid",
              type: "text",
              placeholder: "",
              name: "phone",
              autocomplete: "off"
            }, null, 512), [
              [_vModelText, _ctx.supplierId]
            ]),
            _hoisted_13
          ]))
        : _createCommentVNode("", true),
      (_ctx.Platform == 'Trendyol')
        ? (_openBlock(), _createElementBlock("label", _hoisted_14, "Api Key"))
        : (_openBlock(), _createElementBlock("label", _hoisted_15, "Kullanıcı Adı")),
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.UserName) = $event)),
        class: "form-control form-control-solid",
        type: "text",
        placeholder: "",
        name: "phone",
        autocomplete: "off"
      }, null, 512), [
        [_vModelText, _ctx.UserName]
      ])
    ]),
    (_ctx.Platform == 'Trendyol')
      ? (_openBlock(), _createElementBlock("label", _hoisted_16, "Api Secret"))
      : (_openBlock(), _createElementBlock("label", _hoisted_17, "Şifre")),
    _withDirectives(_createElementVNode("input", {
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.Password) = $event)),
      class: "form-control form-control-solid",
      type: "text",
      placeholder: "",
      name: "password",
      autocomplete: "off"
    }, null, 512), [
      [_vModelText, _ctx.Password]
    ]),
    _hoisted_18,
    _createElementVNode("div", _hoisted_19, [
      (_ctx.HideGT)
        ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
            _hoisted_21,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.Branch, (item, index) => {
              return (_openBlock(), _createElementBlock("div", { key: index }, [
                _hoisted_22,
                (_ctx.Platform == 'Trendyol')
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "btn btn-lg btn-primary fw-bolder me-4",
                      onClick: ($event: any) => {
              _ctx.selectedBranch = item.Id;
              _ctx.sendtrendyol('trendyol');
            }
                    }, _toDisplayString(item.Name), 9, _hoisted_23))
                  : (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      class: "btn btn-lg btn-primary fw-bolder me-4",
                      onClick: ($event: any) => {
              _ctx.selectedBranch = item.Id;
              _ctx.sendgetir('getir');
            }
                    }, _toDisplayString(item.Name), 9, _hoisted_24))
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      (_ctx.HideOtp)
        ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
            _hoisted_26,
            _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.channelValue) + " adresine gönderilen doğrulama kodunu giriniz. ", 1),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.OtpCode) = $event)),
              class: "form-control form-control-solid",
              type: "text",
              inputmode: "numeric",
              placeholder: "Doğrulama kodu",
              autocomplete: "one-time-code"
            }, null, 512), [
              [_vModelText, _ctx.OtpCode]
            ]),
            _hoisted_28,
            _createElementVNode("button", {
              class: "btn btn-lg btn-primary fw-bolder me-4",
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.verifyOtp && _ctx.verifyOtp(...args)))
            }, " Doğrula ")
          ]))
        : _createCommentVNode("", true),
      (_ctx.HideYs)
        ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
            _hoisted_30,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.Branch, (item, index) => {
              return (_openBlock(), _createElementBlock("div", { key: index }, [
                _hoisted_31,
                _createElementVNode("button", {
                  class: "btn btn-lg btn-primary fw-bolder me-4",
                  onClick: ($event: any) => {
              _ctx.selectedBranch = item.Id;
              _ctx.sendyemeksepeti('yemeksepeti');
            }
                }, _toDisplayString(item.Name), 9, _hoisted_32)
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      (_ctx.HideMenu)
        ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
            _hoisted_34,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.Menu, (item, index) => {
              return (_openBlock(), _createElementBlock("div", { key: index }, [
                _hoisted_35,
                _createElementVNode("button", {
                  class: "btn btn-lg btn-primary fw-bolder me-4",
                  onClick: ($event: any) => {
              _ctx.selectedMenu = item.id;
              _ctx.sendyemeksepeti('yemeksepeti');
            }
                }, _toDisplayString(item.title.tr_TR), 9, _hoisted_36)
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      (!_ctx.Hide)
        ? (_openBlock(), _createElementBlock("button", {
            key: 4,
            type: "submit",
            class: "btn btn-lg btn-primary fw-bolder me-4",
            onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.okeybutton && _ctx.okeybutton(...args)))
          }, " Tamamla "))
        : _createCommentVNode("", true)
    ])
  ]))
}